module.exports = __webpack_public_path__ + "img/18_43.109400d2.png";